import { z } from 'zod';

import { LiquidationId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertLiquidationSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  liquidationId: LiquidationId,
});
export const UpsertLiquidationSideEffect = UpsertLiquidationSideEffectContext.extend({
  type: z.literal('upsertLiquidation'),
});
export type UpsertLiquidationSideEffect = z.infer<typeof UpsertLiquidationSideEffect>;
